<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field id="prompt-name" v-model="node.name" label="Name" dense>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0">
        <draggable
          class="list-group"
          tag="div"
          v-model="property.bot_says"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <v-row
              v-for="(element, index) in property.bot_says"
              :key="element.order"
            >
              <v-col
                cols="12"
                sm="12"
                lg="12"
                class="d-flex cursor-pointer align-start m-b-15 p-t-0 p-b-0"
              >
                <prompt-payload
                  :index="index"
                  :prompt="element"
                  :minioHost="minioHost"
                  :voicePaths="voicePaths"
                  :parameters="parameters"
                  :categories="categories"
                  :isMainPlaying="isPlaying"
                  @isSubPlaying="isSubPlaying"
                  @deletePrompt="deletePrompt"
                  style="width: 100%"
                  :key="element.order"
                  :ttsProperty="drawFlowItems.Home.data['1'].data.property.tts"
                  :drawFlowItems="drawFlowItems"
                  :apiForIntellisense="apiForIntellisense"
                />
                <!--use for Intellisense มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </transition-group>
        </draggable>

        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex pt-0 pb-0">
            <div>
              <v-menu :absolute="true">
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex" v-bind="attrs" v-on="on">
                    <v-icon small class="m-r-5">fa-plus-circle</v-icon>
                    <div>Add prompt</div>
                  </div>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(option, index) in voiceOptions"
                    :key="index"
                    @click="voiceOptionClick(option.action)"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        :id="`list${index}`"
                        class="font-size-body"
                      >
                        <v-icon
                          small
                          class="width20px m-r-10"
                          :style="
                            `font-size: ${
                              option.iconWidth ? option.iconWidth : '16px'
                            }`
                          "
                        >
                          {{ option.icon }}
                        </v-icon>
                        {{ option.title }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex cursor-pointer" @click="playAllClick">
              <v-progress-circular
                v-if="ttsLoading"
                indeterminate
                :size="16"
                :width="2"
              ></v-progress-circular>
              <v-icon v-else small :disabled="property.bot_says.length === 0">{{
                isPlayingAll ? 'fa-stop-circle' : 'fa-play-circle'
              }}</v-icon>
              <div class="m-l-5">Play all</div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import draggable from '@/plugins/vuedraggable'
import PromptPayload from './payloads/index'
import apiPrompt from '@/apis/prompt'
import apiSynthesis from '@/apis/synthesis'

import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    drawFlowItems: Object,
    // ใช้สำหรับ intellisense code
    apiForIntellisense: Object
    // ใช้สำหรับ intellisense code
  },
  components: {
    draggable,
    PromptPayload,
    NoteComponent
  },
  data() {
    return {
      property: {},
      rules: {
        required: value => !!value || 'Required.'
      },
      order: 1,
      voiceOptions: [
        {
          title: 'Text-to-speech',
          icon: 'mdi-chat-processing-outline',
          iconWidth: '20px',
          action: 'tts'
        },
        {
          title: 'TTS cache',
          icon: 'mdi-chat-plus-outline',
          iconWidth: '20px',
          action: 'tts_cache'
        },
        { title: 'Static audio', icon: 'fa-volume-up', action: 'file' },
        { title: 'Variable', icon: 'fa-dollar-sign', action: 'parameter' },
        { title: 'URL', icon: 'fa-link', action: 'url' },
        { title: 'Pause', icon: 'fa-ellipsis-h', action: 'pause' }
      ],
      minioHost: '',
      voicePaths: [],
      parameters: [],
      categories: [
        {
          text: 'Intent',
          value: 'INTENT'
        },
        {
          text: 'Entity',
          value: 'ENTITY'
        },
        {
          text: 'Alphabet',
          value: 'ALPHABET'
        },
        {
          text: 'Digit',
          value: 'DIGIT'
        },
        {
          text: 'Phone number',
          value: 'PHONE_NUMBER'
        },
        {
          text: 'Thai ID (1-4-5-3)',
          value: 'THAI_ID'
        },
        {
          text: 'Thai ID (3-3-3-4)',
          value: 'THAI_ID_3334'
        },
        {
          text: 'Thai ID (4-4-5)',
          value: 'THAI_ID_445'
        },
        {
          text: 'Thai ID (5-5-3)',
          value: 'THAI_ID_553'
        },
        {
          text: 'Thai ID (13)',
          value: 'THAI_ID_13'
        },
        {
          text: 'Number',
          value: 'NUMBER'
        },
        {
          text: 'Amount - THB',
          value: 'AMOUNT_THB'
        },
        {
          text: 'Date - Long (BE)',
          value: 'DATE_LONG_BE',
          tooltip: 'วันศุกร์ที่ สอง ธันวาคม สองพันห้าร้อยหกสิบห้า'
        },
        {
          text: 'Date - Medium (BE)',
          value: 'DATE_MEDIUM_BE',
          tooltip: 'วันที่ สอง ธันวาคม สองห้าหกห้า'
        },
        {
          text: 'Date - Short',
          value: 'DATE_SHORT',
          tooltip: 'วันที่ สอง ธันวาคม'
        },
        {
          text: 'Date - Casual (BE)',
          value: 'DATE_CASUAL_BE',
          tooltip:
            'เมื่อวานนี้, วันนี้, พรุ่งนี้<br>วันที่ สอง ธันวา ที่ผ่านมา / นี้<br>วันที่ สอง ธันวา หกหก'
        },
        {
          text: 'Time',
          value: 'TIME'
        }
      ],
      isPlaying: false,
      indexPlayAll: 0,
      playAllVoice: [],
      isPlayingAll: false,
      timeout: null,
      previewVoice: '',
      ttsLoading: false
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
        filter: '.no-drag',
        preventOnFilter: false
      }
    }
  },
  async created() {
    this.property = this.node.property
    for (let i = 0; i < this.property.bot_says.length; i++) {
      this.order =
        this.order <= this.property.bot_says[i].order
          ? this.property.bot_says[i].order + 1
          : this.order
    }
    await this.initial()
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlayingAll = true
    })
    this.$refs.myAudio.addEventListener('ended', async () => {
      this.indexPlayAll += 1
      this.playAudio(this.indexPlayAll)
    })
  },
  methods: {
    async initial() {
      await this.getPrompt()
      await this.getVoicePath()
      await this.getParameter()
    },
    async getPrompt() {
      try {
        const getPrompts = await apiPrompt.getVoicePromptAll()
        this.minioHost = getPrompts.minio_url
      } catch (error) {}
    },
    async getVoicePath() {
      try {
        this.voicePaths = []
        const getVoicePath = await apiPrompt.getVoicePath()
        const { data } = getVoicePath
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj._id = data[i]._id ? data[i]._id : ''
          obj.text = data[i].text ? data[i].text : ''
          obj.path = data[i].path ? data[i].path : ''
          obj.sign_url = data[i].sign_url ? data[i].sign_url : ''
          this.voicePaths.push(obj)
        }
      } catch (error) {}
    },
    async getParameter() {
      try {
        this.parameters = []
        const getParameter = await apiPrompt.getParameter()
        const { data } = getParameter
        this.parameters = data
      } catch (error) {}
    },
    voiceOptionClick(action) {
      let template = {}
      switch (action) {
        case 'tts':
          template = {
            type: 'tts',
            text: '',
            video: ''
          }
          break
        case 'tts_cache':
          template = {
            type: 'tts_cache',
            text: '',
            video: ''
          }
          break
        case 'file':
          template = {
            type: 'file',
            path: ''
          }
          break
        case 'parameter':
          template = {
            type: 'parameter',
            say_as: '',
            variable: ''
          }
          break
        case 'url':
          template = {
            type: 'url',
            url: '',
            transcription: ''
          }
          break
        case 'pause':
          template = {
            type: 'pause',
            value: 0.5
          }
          break
      }
      template.order = this.order
      if (template.type) this.property.bot_says.push(template)
      this.order += 1
    },
    deletePrompt(index) {
      this.property.bot_says.splice(index, 1)
    },
    isSubPlaying() {
      if (this.isPlaying) {
        this.$refs.myAudio.pause()
        this.isPlaying = false
      }
    },
    async playAllClick() {
      if (!this.isPlayingAll) {
        this.playAllVoice = []

        if (this.property.bot_says.length > 0) this.ttsLoading = true

        for (let i = 0; i < this.property.bot_says.length; i++) {
          if (this.property.bot_says[i].type === 'tts') {
            const tts = await apiSynthesis.synthesis({
              ...this.drawFlowItems.Home.data['1'].data.property.tts,
              text: this.property.bot_says[i].text,
              useCache: true
            })
            this.playAllVoice.push({ type: 'voice', audio: tts.data.audio })
          } else if (
            this.property.bot_says[i].type === 'file' &&
            this.property.bot_says[i].path
          ) {
            const find = _.find(this.voicePaths, {
              path: this.property.bot_says[i].path
            })
            if (find) {
              this.playAllVoice.push({
                type: 'voice',
                audio: find.sign_url //`${this.minioHost}${this.property.bot_says[i].path}`
              })
            }
          } else if (
            this.property.bot_says[i].type === 'url' &&
            this.property.bot_says[i].url
          ) {
            this.playAllVoice.push({
              type: 'voice',
              audio: this.property.bot_says[i].url
            })
          } else if (this.property.bot_says[i].type === 'pause') {
            this.playAllVoice.push({
              type: 'pause',
              value: this.property.bot_says[i].value
            })
          }
        }
      }

      this.indexPlayAll = 0
      const currectAudio = this.playAllVoice[this.indexPlayAll]
      if (this.isPlayingAll) {
        this.isPlayingAll = false

        if (currectAudio.type === 'voice') {
          this.$refs.myAudio.pause()
        } else {
          if (this.timeout) clearTimeout(this.timeout)
        }
      } else {
        this.isPlayingAll = true

        this.indexPlayAll = 0
        await this.playAudio(this.indexPlayAll)
      }
    },
    async playAudio(index) {
      if (index < this.playAllVoice.length) {
        const obj = this.playAllVoice[index]
        if (obj.type === 'pause') {
          await new Promise(
            resolve => (this.timeout = setTimeout(resolve, obj.value * 1000))
          )

          if (this.isPlayingAll) {
            this.indexPlayAll += 1
            await this.playAudio(this.indexPlayAll)
          }
        } else {
          this.previewVoice = this.playAllVoice[index].audio
          this.$refs.myAudio.load()

          setTimeout(() => {
            this.$refs.myAudio.play()
            this.ttsLoading = false
          }, 300)
        }
      } else {
        this.indexPlayAll = 0
        this.isPlayingAll = false
        this.previewVoice = ''
      }
    }
  }
}
</script>

<style scope lang="scss">
.width20px {
  width: 20px;
}
</style>
